import { render, staticRenderFns } from "./UsuariosPage.vue?vue&type=template&id=36f65234"
import script from "./UsuariosPage.vue?vue&type=script&lang=js"
export * from "./UsuariosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports